import { RestaurantUtils } from "../restaurant";
import { v4 as uuid } from "uuid";
import { formatCurrency } from "../index";
import Big from "big.js";
function dishIngredients(args) {
    const { md, od, menus, odChoiceId } = args;
    // Get option sets for a dish
    if (!odChoiceId) {
        return md.ingredients;
    }
    const dishChoice = od.choices.find((c) => c.id === odChoiceId);
    const { dish } = RestaurantUtils.menu.findDish(menus, dishChoice.dish_id);
    return dish.ingredients;
}
function dishChoices(args) {
    const { md, menus, odChoiceId, availabilityCheck } = args;
    const menuChoice = md.choices.find((c) => c.id === odChoiceId);
    const options = [];
    for (const menu of menus) {
        for (const category of menu.categories) {
            const availability = availabilityCheck(category);
            for (const d of category.dishes) {
                const found = menuChoice.dishes.findIndex((dish) => dish.dish_id === d.id);
                if (found !== -1) {
                    const price = menuChoice.dishes[found].price;
                    const o = {
                        label: d.display_name || d.name,
                        sublabel: price === 0 ? "" : `+${formatCurrency(price)}`,
                        value: d.id,
                        disabled: false,
                    };
                    if (d.status === "no_stock") {
                        o.sublabel = `Out of stock`;
                        o.disabled = true;
                    }
                    else if (availability.isRestricted) {
                        o.sublabel = availability.reason === "age" ? `Adults (18+)` : "Unavailable";
                    }
                    options.push(o);
                }
            }
        }
    }
    return options;
}
function dishChoicesGrouped(args) {
    const { md, menus, odChoiceId, availabilityCheck } = args;
    const menuChoice = md.choices.find((c) => c.id === odChoiceId);
    const categories = [];
    for (const menu of menus) {
        for (const category of menu.categories) {
            const availability = availabilityCheck(category);
            for (const d of category.dishes) {
                const found = menuChoice.dishes.findIndex((dish) => dish.dish_id === d.id);
                if (found !== -1) {
                    const price = menuChoice.dishes[found].price;
                    const o = {
                        label: d.display_name || d.name,
                        sublabel: price === 0 ? "" : `+${formatCurrency(price)}`,
                        value: d.id,
                        disabled: false,
                    };
                    if (d.status === "no_stock") {
                        o.sublabel = `Out of stock`;
                        o.disabled = true;
                    }
                    else if (availability.isRestricted) {
                        o.sublabel = availability.reason === "age" ? `Adults (18+)` : "Unavailable";
                    }
                    const categoryIndex = categories.findIndex((c) => c.id === category.id);
                    if (categoryIndex === -1) {
                        categories.push({
                            id: category.id,
                            name: category.name,
                            dishes: [o],
                        });
                    }
                    else {
                        categories[categoryIndex].dishes.push(o);
                    }
                }
            }
        }
    }
    return categories;
}
function dishPrice(args) {
    const { dish, service } = args;
    if (service === "pickup" && dish.price_pickup) {
        return dish.price_pickup;
    }
    else if (service === "delivery" && dish.price_delivery) {
        return dish.price_delivery;
    }
    else if (service === "dine_in" && dish.price_dine_in) {
        return dish.price_dine_in;
    }
    return dish.price;
}
export const menuDish = {
    price: dishPrice,
    ingredients: dishIngredients,
    choices: dishChoices,
    choicesGrouped: dishChoicesGrouped,
};
function menuOptionSetsForDish(args) {
    const { r, md, odChoiceDishId, platform, service } = args;
    let optionSets;
    // For standard dish, not combo dish choice
    if (!odChoiceDishId) {
        // Get option sets for dish
        const dishOptionSetIds = md.option_sets.map((os) => os.option_set_id);
        optionSets = r.option_sets.filter((os) => dishOptionSetIds.indexOf(os.id) !== -1);
    }
    else {
        // For combo dish choice, find the choice in menu
        const { dish: comboDish } = RestaurantUtils.menu.findDish(r.menus, odChoiceDishId);
        // Get option sets for dish choice
        const comboDishOptionSetIds = comboDish.option_sets.map((os) => os.option_set_id);
        optionSets = r.option_sets.filter((os) => comboDishOptionSetIds.indexOf(os.id) !== -1);
        // If some option sets are blacklisted, filter them out
        if (md.option_set_blacklist.length > 0) {
            optionSets = optionSets.filter((os) => {
                const index = md.option_set_blacklist.findIndex((osb) => osb.option_set_id === os.id);
                return index === -1;
            });
        }
    }
    // Filter option set based on hide preferences
    optionSets = optionSets.filter((os) => {
        if (os.hide)
            return false;
        if (os.hide_online && platform === "online")
            return false;
        if (os.hide_pos && platform === "pos")
            return false;
        if (os.hide_combo && !!odChoiceDishId)
            return false;
        if (os.hide_standard && !odChoiceDishId)
            return false;
        if (os.hide_pickup && service === "pickup")
            return false;
        if (os.hide_delivery && service === "delivery")
            return false;
        if (os.hide_dine_in && service === "dine_in")
            return false;
        return true;
    });
    return optionSets;
    // Surcharge applied directly on option
    // Apply surcharge and return
    // return optionSets.map((os) => menuOptionSetsSurcharge({ os, surchargePct }));
}
/*
function menuOptionSetsSurcharge(args: {
  os: RestaurantMenuDishOptionSetFullFragment;
  surchargePct: Surcharge;
}): RestaurantMenuDishOptionSetFullFragment {
  const { os, surchargePct } = args;
  if (!args.surchargePct) return os;
  return {
    ...os,
    options: os.options.map((option) => {
      return {
        ...option,
        price:
          itemPriceSurcharge({
            price: option.price,
            surchargePct: surchargePct,
          }) || 0,
        price_pickup:
          typeof option.price_pickup !== "number"
            ? null
            : itemPriceSurcharge({
                surchargePct,
                price: option.price_pickup,
              }),
        price_delivery:
          typeof option.price_delivery !== "number"
            ? null
            : itemPriceSurcharge({
                surchargePct,
                price: option.price_delivery,
              }),
        price_dine_in:
          typeof option.price_dine_in !== "number"
            ? null
            : itemPriceSurcharge({
                surchargePct,
                price: option.price_dine_in,
              }),
        price_combo:
          typeof option.price_combo !== "number"
            ? null
            : itemPriceSurcharge({
                surchargePct,
                price: option.price_combo,
              }),
        price_combo_pickup:
          typeof option.price_combo_pickup !== "number"
            ? null
            : itemPriceSurcharge({
                surchargePct,
                price: option.price_combo_pickup,
              }),
        price_combo_delivery:
          typeof option.price_combo_delivery !== "number"
            ? null
            : itemPriceSurcharge({
                surchargePct,
                price: option.price_combo_delivery,
              }),
        price_combo_dine_in:
          typeof option.price_combo_dine_in !== "number"
            ? null
            : itemPriceSurcharge({
                surchargePct,
                price: option.price_combo_dine_in,
              }),
        vary_prices: option.vary_prices.map((vary) => {
          return {
            ...vary,
            price:
              itemPriceSurcharge({
                surchargePct,
                price: vary.price,
              }) || 0,
          };
        }),
      };
    }),
  };
}
*/
function menuOptionSetsControlType(args) {
    const { os } = args;
    // Get option set control type
    return os.is_multi && os.is_quantity ? "hitbox" : "switch";
}
function menuOptionSetsDescription(args) {
    const { os } = args;
    // Get description for option set
    let intlKey;
    let intlValues = {};
    let label = "";
    if (os.is_multi) {
        if (os.is_required && os.max_options) {
            intlKey = "select_between";
            intlValues = {
                min: os.min_options || 0,
                max: os.max_options,
            };
            label = `Select between ${intlValues.min} - ${intlValues.max} (Required)`;
        }
        else if (os.is_required && os.min_options) {
            intlKey = "select_at_least";
            intlValues = { qty: os.min_options || 1 };
            label = `Select at least ${os.min_options || 1} (Required)`;
        }
        else if (os.max_options) {
            intlKey = "select_up_to";
            intlValues = { qty: os.max_options };
            label = `Select up to ${os.max_options} (Optional)`;
        }
        else {
            intlKey = "select_multiple";
            label = "Select multiple (Optional)";
        }
    }
    else {
        intlKey = os.is_required ? "select_one" : "select_one_optional";
        label = os.is_required ? "Select one (Required)" : "Select one (Optional)";
    }
    return { label, intlKey, intlValues };
}
export const menuOptionSets = {
    forDish: menuOptionSetsForDish,
    description: menuOptionSetsDescription,
    controlType: menuOptionSetsControlType,
    // surcharge: menuOptionSetsSurcharge,
    // optionsForDish: menuOptionSetsOptionsForDish,
};
function itemPriceSurcharge(args) {
    const { price, surchargePct } = args;
    if (price === 0)
        return 0;
    if (!price)
        return null;
    if (!surchargePct || surchargePct <= 0)
        return price;
    const base = Big(surchargePct).div(100).times(price).plus(price).toFixed(0);
    return Math.ceil(parseInt(base, 10) / 10) * 10;
}
export const menuUtility = {
    surcharge: itemPriceSurcharge,
};
function orderOptionsTotal(options) {
    return options.reduce((price, { option }) => {
        const billableQuantity = option.quantity - (option.quantity_free || 0);
        if (billableQuantity > 0) {
            price += billableQuantity * (option.price || 0);
        }
        return price;
    }, 0);
}
function orderOptionsPrice(args) {
    const { option, od, odChoiceId, service, surchargePct } = args;
    const { price_pickup, price_delivery, price_dine_in, price_combo, price_combo_pickup, price_combo_delivery, price_combo_dine_in, } = option;
    let price;
    if (od) {
        for (const optionSelected of orderOptionsInDish({ od, odChoiceId })) {
            for (const vary of option.vary_prices) {
                if (optionSelected.option.option_id === vary.vary_option_id) {
                    if (typeof vary.price === "number") {
                        price = vary.price;
                        break;
                    }
                }
            }
        }
    }
    if (typeof price !== "number" && !!odChoiceId) {
        if (typeof price_combo_pickup === "number" && service === "pickup") {
            price = price_combo_pickup;
        }
        else if (typeof price_combo_delivery === "number" && service === "delivery") {
            price = price_combo_delivery;
        }
        else if (typeof price_combo_dine_in === "number" && service === "dine_in") {
            price = price_combo_dine_in;
        }
        else if (typeof price_combo === "number") {
            price = price_combo;
        }
    }
    if (typeof price !== "number") {
        if (typeof price_pickup === "number" && service === "pickup") {
            price = price_pickup;
        }
        else if (typeof price_delivery === "number" && service === "delivery") {
            price = price_delivery;
        }
        else if (typeof price_dine_in === "number" && service === "dine_in") {
            price = price_dine_in;
        }
    }
    if (typeof price !== "number") {
        price = option.price;
    }
    // console.log(option.name, price);
    return !surchargePct
        ? price
        : itemPriceSurcharge({
            surchargePct,
            price,
        }) || 0;
}
function orderOptionsIdsInCart(args) {
    const { dishes } = args;
    return dishes.reduce((ids, dish) => {
        for (const opt of dish.options) {
            ids.push(opt.option.id);
        }
        for (const choice of dish.choices) {
            for (const opt of choice.options) {
                ids.push(opt.option.id);
            }
        }
        return ids;
    }, []);
}
function orderOptionsFromMenuOption(args) {
    const { os, option, position } = args;
    // Convert menu option to order option
    return {
        id: uuid(),
        option_set_id: os.id,
        option_id: option.id,
        set_name: os.display_name || os.name,
        name: option.name,
        quantity: 1,
        quantity_free: 0,
        price: option.price,
        position: position,
    };
}
function orderOptionsForDish(args) {
    const { optionSet, od, odChoiceId, platform, service } = args;
    const optionsSelected = orderOptionsInDish({ od, odChoiceId });
    return optionSet.options.filter((o) => {
        if (o.hide)
            return false;
        if (o.hide_online && platform === "online")
            return false;
        if (o.hide_pos && platform === "pos")
            return false;
        if (o.hide_combo && !!odChoiceId)
            return false;
        if (o.hide_standard && !odChoiceId)
            return false;
        if (o.hide_pickup && service === "pickup")
            return false;
        if (o.hide_delivery && service === "delivery")
            return false;
        if (o.hide_dine_in && service === "dine_in")
            return false;
        for (const v of o.vary_prices) {
            if (typeof v.visibility === "number") {
                const optionSelected = optionsSelected.find((selected) => selected.option.option_id === v.vary_option_id);
                if (v.visibility === 1 && !!optionSelected) {
                    // Hide when selected
                    return false;
                }
                else if (v.visibility === 2 && !optionSelected) {
                    // Hide when not selected
                    return false;
                }
            }
        }
        return true;
    });
}
function orderOptionsInDish(args) {
    const { od, odChoiceId } = args;
    // Get options for order dish
    if (!odChoiceId) {
        return od.options;
    }
    return od.choices.find((c) => c.id === odChoiceId).options;
}
function orderOptionsInDishBySet(args) {
    const { od, optionSetId, odChoiceId } = args;
    // Get options for option set in an order dish
    const options = orderOptionsInDish({ od, odChoiceId });
    return options.filter((o) => o.option.option_set_id === optionSetId);
}
function orderOptionsInDishById(args) {
    const { od, option, odChoiceId } = args;
    // Get specific option from order dish
    return orderOptionsInDish({ od, odChoiceId }).find((o) => o.option.option_id === option.id);
}
function orderOptionsSetFreeAvailable(args) {
    const { od, os, odChoiceId } = args;
    // Get number of free option choices available for option set
    const selectedOptions = orderOptionsInDishBySet({
        od: od,
        optionSetId: os.id,
        odChoiceId: odChoiceId,
    });
    const totalFree = os.free_amount || 0;
    const totalSelected = selectedOptions.reduce((total, o) => total + o.option.quantity, 0);
    const remaining = totalFree - totalSelected;
    return {
        freeTotal: totalFree,
        freeRemaining: remaining < 0 ? 0 : remaining,
        totalSelected: totalSelected,
    };
}
export const orderOptions = {
    total: orderOptionsTotal,
    price: orderOptionsPrice,
    idsInCart: orderOptionsIdsInCart,
    fromMenuOption: orderOptionsFromMenuOption,
    forDish: orderOptionsForDish,
    inDish: orderOptionsInDish,
    inDishBySet: orderOptionsInDishBySet,
    inDishById: orderOptionsInDishById,
    freeAvailable: orderOptionsSetFreeAvailable,
};
function orderOptionsMutSelect(args) {
    const { od, os, option, odChoiceId, optionAdd, optionRemove } = args;
    // Update option for toggle selection
    const orderOptions = orderOptionsInDish({ od, odChoiceId });
    if (option.no_stock) {
        return;
    }
    if (!os.is_multi) {
        let index = orderOptions.length;
        while (index > 0) {
            index--;
            const oo = orderOptions[index];
            if (oo.option.option_set_id === os.id && oo.option.option_id !== option.id) {
                optionRemove(index);
            }
        }
    }
    const orderOptionIndex = orderOptions.findIndex((o) => o.option.option_id === option.id);
    if (orderOptionIndex !== -1 && orderOptions[orderOptionIndex].option.quantity === 1) {
        optionRemove(orderOptionIndex);
    }
    else {
        optionAdd(orderOptionsFromMenuOption({
            os: os,
            option: option,
            position: orderOptions.length,
        }));
    }
}
function orderOptionsMutSelectHitBox(args) {
    const { od, os, option, odChoiceId, direction, optionAdd, optionRemove, optionEditQty } = args;
    // Update option for hit-box selection
    const orderOptions = orderOptionsInDish({ od, odChoiceId });
    if (option.no_stock) {
        return;
    }
    const orderOptionIndex = orderOptions.findIndex((o) => o.option.option_id === option.id);
    if (orderOptionIndex !== -1) {
        if (orderOptions[orderOptionIndex].option.quantity === 1 && direction === "down") {
            optionRemove(orderOptionIndex);
        }
        else {
            optionEditQty(orderOptionIndex, direction === "up" ? 1 : -1);
        }
    }
    else if (direction === "up") {
        optionAdd(orderOptionsFromMenuOption({
            os: os,
            option: option,
            position: orderOptions.length,
        }));
    }
}
function orderOptionsMutCalc(args) {
    const { od, odChoiceId, service, surchargePct } = args;
    // Update option prices and sort order (mutates the inputs)
    const menuOptionSets = menuOptionSetsForDish(args);
    const orderOptions = orderOptionsInDish({ od, odChoiceId });
    const freeOptions = {};
    let index = 0;
    for (const oo of orderOptions) {
        const os = menuOptionSets.find((mos) => mos.id === oo.option.option_set_id);
        const option = os.options.find((mo) => mo.id === oo.option.option_id);
        oo.option.price = orderOptionsPrice(Object.assign(Object.assign({}, args), { option }));
        if (os.free_amount) {
            if (typeof freeOptions[os.id] === "undefined") {
                freeOptions[os.id] = os.free_amount;
            }
            if (freeOptions[os.id] > 0) {
                if (freeOptions[os.id] >= oo.option.quantity) {
                    oo.option.quantity_free = oo.option.quantity;
                    freeOptions[os.id] -= oo.option.quantity;
                }
                else {
                    oo.option.quantity_free = freeOptions[os.id];
                    freeOptions[os.id] = 0;
                }
            }
            else {
                oo.option.quantity_free = 0;
            }
        }
        oo.option.position = index;
        index++;
    }
    let positionIndex = 0;
    const orderOptionSorted = menuOptionSets.reduce((sorted, os) => {
        const orderOptionsInSet = orderOptions.filter((oo) => oo.option.option_set_id === os.id);
        for (const oo of orderOptionsInSet) {
            sorted.push({
                option: Object.assign(Object.assign({}, oo.option), { position: positionIndex }),
            });
            positionIndex++;
        }
        return sorted;
    }, []);
    if (!odChoiceId) {
        od.options = orderOptionSorted;
    }
    else {
        const choiceIndex = od.choices.findIndex((c) => {
            return c.id === odChoiceId;
        });
        od.choices[choiceIndex].options = orderOptionSorted;
    }
}
export const orderOptionsMut = {
    select: orderOptionsMutSelect,
    selectHitBox: orderOptionsMutSelectHitBox,
    calc: orderOptionsMutCalc,
};
function orderDishTotal(dish) {
    // Base price is just item + options + combo choices
    let basePrice = dish.price;
    if (dish.type === "combo") {
        for (const choice of dish.choices) {
            basePrice += choice.price || 0;
            basePrice += orderOptionsTotal(choice.options);
        }
    }
    else {
        basePrice += orderOptionsTotal(dish.options);
    }
    // Final price includes discounts or surcharges
    let finalPrice = basePrice;
    finalPrice -= dish.discount || 0;
    finalPrice += dish.surcharge || 0;
    const priceDiff = finalPrice - basePrice;
    const priceDiffPct = priceDiff / basePrice;
    return {
        price: finalPrice * dish.quantity,
        priceSingle: finalPrice,
        basePrice: basePrice * dish.quantity,
        basePriceSingle: basePrice,
        priceDiffSingle: priceDiff,
        priceDiffSinglePct: priceDiffPct,
    };
}
function orderDishExistingIndex(args) {
    const { md, od, cart, prePopup, skipIfPaid } = args;
    if (prePopup) {
        if (md.type === "combo" || md.ingredients.length > 0 || md.option_sets.length > 0) {
            return -1;
        }
    }
    if (od.type === "combo" ||
        od.options.length > 0 ||
        od.ingredients.length > 0 ||
        !!od.discount ||
        !!od.notes) {
        return -1;
    }
    for (const [index, cartItem] of cart.entries()) {
        if (cartItem.dish_id === md.id) {
            if (!!cartItem.created) {
                // Don't match items that have already been saved in the system
                // Let them go to their own line, so they get printed out in print diff
                continue;
            }
            // if (!!orderUpdated && !!cartItem.created) {
            //   if (cartItem.created <= orderUpdated) {
            //     continue;
            //   }
            // }
            if (skipIfPaid && !!cartItem.payment_id) {
                continue;
            }
            if (((!od.table_seat_num && !cartItem.table_seat_num) ||
                od.table_seat_num === cartItem.table_seat_num) &&
                cartItem.notes === "" &&
                cartItem.options.length === 0 &&
                cartItem.ingredients.length === 0 &&
                cartItem.discount === 0) {
                return index;
            }
        }
    }
    return -1;
}
function orderDishErrors(args) {
    const { md, od } = args;
    const choiceErrors = {};
    const optionErrors = {};
    if (od.type === "combo") {
        for (const comboChoice of md.choices) {
            const selectedChoice = od.choices.findIndex((c) => c.choice_id === comboChoice.id);
            if (selectedChoice === -1) {
                choiceErrors[comboChoice.id] = true;
            }
        }
        for (const selectedChoice of od.choices) {
            // const find = RestaurantUtils.menu.findDish(menus, selectedChoice.dish_id!)!;
            // Remove blacklisted option sets
            const choiceOptionSets = menuOptionSetsForDish(Object.assign(Object.assign({}, args), { odChoiceDishId: selectedChoice.dish_id }));
            const odOptions = selectedChoice.options.map(({ option }) => option);
            for (const os of choiceOptionSets) {
                const result = RestaurantUtils.dish.optionSetValidate(os, odOptions);
                if (result.error) {
                    optionErrors[`${selectedChoice.id}-${os.id}`] = true;
                }
            }
        }
    }
    else {
        const menuDishOptionSets = menuOptionSetsForDish(Object.assign(Object.assign({}, args), { odChoiceDishId: null }));
        const odOptions = od.options.map(({ option }) => option);
        for (const os of menuDishOptionSets) {
            const result = RestaurantUtils.dish.optionSetValidate(os, odOptions);
            if (result.error) {
                optionErrors[os.id] = true;
            }
        }
    }
    return { optionErrors, choiceErrors };
}
function orderDishIngredientsAllInCart(args) {
    const { dishes } = args;
    return dishes.reduce((ids, dish) => {
        for (const ing of dish.ingredients) {
            ids.push(ing.ingredient.id);
        }
        for (const choice of dish.choices) {
            for (const ing of choice.ingredients) {
                ids.push(ing.ingredient.id);
            }
        }
        return ids;
    }, []);
}
function orderDishIngredientsRemoved(args) {
    const { od, odChoiceId } = args;
    return !odChoiceId ? od.ingredients : od.choices.find((c) => c.id === odChoiceId).ingredients;
}
function orderDishIngredientActive(args) {
    const { id, od, odChoiceId } = args;
    const ingredientsRemoved = orderDishIngredientsRemoved({ od, odChoiceId });
    const findIndex = ingredientsRemoved.findIndex((i) => i.ingredient.ingredient_id === id);
    return {
        index: findIndex,
        active: findIndex === -1,
    };
}
function orderDishComboChoiceIdsInCart(args) {
    const { dishes } = args;
    return dishes.reduce((ids, dish) => {
        for (const choice of dish.choices) {
            ids.push(choice.id);
        }
        return ids;
    }, []);
}
export const orderDish = {
    total: orderDishTotal,
    existingIndex: orderDishExistingIndex,
    errors: orderDishErrors,
    ingredientsAllIdsInCart: orderDishIngredientsAllInCart,
    ingredientsRemoved: orderDishIngredientsRemoved,
    ingredientActive: orderDishIngredientActive,
    comboChoiceIdsInCart: orderDishComboChoiceIdsInCart,
};
function orderDishMutIngredientToggle(args) {
    const { ing, od, odChoiceId, add, remove } = args;
    const { index } = orderDishIngredientActive({ id: ing.id, od, odChoiceId });
    const ingredientsRemoved = orderDishIngredientsRemoved({ od, odChoiceId });
    if (index !== -1) {
        remove(index);
    }
    else {
        add({
            ingredient: {
                id: uuid(),
                ingredient_id: ing.id,
                name: ing.name,
                position: ingredientsRemoved.length,
            },
        });
    }
}
function orderDishMutComboChoiceSet(args) {
    var _a, _b;
    const { md, od, menus, odChoiceId, odChoiceDishId, availabilityCheck, availabilityCallback } = args;
    // Mutates order dish
    const find = RestaurantUtils.menu.findDish(menus, odChoiceDishId);
    const { dish, category } = find;
    const menuChoiceIndex = md.choices.findIndex((c) => c.id === odChoiceId);
    const existingIndex = od.choices.findIndex((c) => c.choice_id === odChoiceId);
    const menuChoice = md.choices[menuChoiceIndex];
    const choice = {
        id: uuid(),
        choice_id: odChoiceId,
        choice_name: menuChoice.name,
        dish_id: odChoiceDishId,
        name: dish.display_name || dish.name,
        print_name: dish.print_name,
        price: (_b = (_a = menuChoice.dishes.find((d) => d.dish_id === odChoiceDishId)) === null || _a === void 0 ? void 0 : _a.price) !== null && _b !== void 0 ? _b : 0,
        position: menuChoiceIndex,
        options: [],
        ingredients: [],
    };
    if (existingIndex === -1) {
        const availability = availabilityCheck(category);
        if (availability.isRestricted) {
            availabilityCallback(availability);
            return;
        }
        od.choices.push(choice);
    }
    else {
        od.choices[existingIndex] = choice;
    }
    // Mobx array sort is immutable
    od.choices = od.choices.slice().sort((a, b) => {
        return a.position - b.position;
    });
}
export const orderDishMut = {
    ingredientToggle: orderDishMutIngredientToggle,
    comboChoiceSet: orderDishMutComboChoiceSet,
};
//# sourceMappingURL=index.js.map